module.exports = __webpack_public_path__ + "img/rca-rs-menu7.0a802755.jpg";